var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9123 1.49536H17.5312L11.8098 8.03453L18.5405 16.9329H13.2696L9.14187 11.5361L4.41879 16.9329H1.79837L7.91796 9.93849L1.46191 1.49536H6.86504L10.5962 6.42824L14.9107 1.49536H14.9123ZM13.9932 15.3654H15.4443L6.07733 2.98053H4.52012L13.9932 15.3654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial2);
export default __webpack_public_path__ + "static/media/social_2.ba7722e3093d16559d86f0999048ab71.svg";
export { ForwardRef as ReactComponent };